// extracted by mini-css-extract-plugin
module.exports = {"blogCard":"card-module--blog-card--9B2Bc","title":"card-module--title--3moSF"};